import React, { useEffect, useRef } from "react";
import "../styles/Contact.css";
import { FaPhone, FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

const Contact: React.FC = () => {
  const mapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const mapEl = mapRef.current;
    if (mapEl) observer.observe(mapEl);

    return () => {
      if (mapEl) observer.unobserve(mapEl);
    };
  }, []);

  return (
    <div className="contact-container">
      <div className="breadcrumb">ANASAYFA / İLETİŞİM</div>
      <h1 className="contact-title">İLETİŞİM BİLGİSİ</h1>

      <div className="contact-single">
        <div className="contact-info-card">
          <div className="contact-item">
            <FaMapMarkerAlt className="contact-icon" />
            <div className="contact-text">
              <h3>Adresimiz</h3>
              <p className="contact-address">
                MOLLA FENARİ MAH. VEZIRHAN CAD.<br />
                NO:55 NURUOSMANIYE, FATİH/İSTANBUL
              </p>

              <div className="contact-channels">
                <a
                  href="https://wa.me/+905465248847"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-channel whatsapp"
                >
                  <FaWhatsapp />
                  <span>0546 524 88 47</span>
                </a>
                <a href="tel:+902128125062" className="contact-channel phone">
                  <FaPhone />
                  <span>0 (212) 812 50 62</span>
                </a>
                <a
                  href="mailto:info@metalkiymetlimadenler.com.tr"
                  className="contact-channel mail"
                >
                  <FaEnvelope />
                  <span>info@metalkiymetlimadenler.com.tr</span>
                </a>
              </div>

              <div className="address-image-container">
                <img
                  src={require("../assets/sube/sube.png")}
                  alt="Metal Kıymetli Madenler Nuruosmaniye Şubesi"
                  className="address-image"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="map-wrapper" ref={mapRef}>
          <div className="map-header">
            <h3>Konum</h3>
            <a
              href="https://maps.app.goo.gl/eYAuUn65pm8RpSMv8"
              target="_blank"
              rel="noopener noreferrer"
              className="directions-button"
            >
              Yol Tarifi Al
            </a>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.7234012531417!2d28.971352699999997!3d41.00942690000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab97dc5856819%3A0xdd61b2ec742aef30!2sMetal%20K%C4%B1ymetli%20Madenler!5e0!3m2!1str!2str!4v1771827790357!5m2!1str!2str"
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: "12px", minHeight: "380px" }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Metal Kıymetli Madenler Şube Harita"
          ></iframe>
        </div>
      </div>

      <div className="icon-bar">
        <a
          href="mailto:info@metalkiymetlimadenler.com.tr"
          className="icon mail"
          aria-label="E-posta Gönder"
        >
          <FaEnvelope />
        </a>
        <a href="tel:+902128125062" className="icon phone" aria-label="Telefon Et">
          <FaPhone />
        </a>
        <a
          href="https://wa.me/+905465248847"
          className="icon whatsapp"
          aria-label="WhatsApp ile İletişime Geç"
        >
          <FaWhatsapp />
        </a>
      </div>
    </div>
  );
};

export default Contact;
